import { defineMessages } from 'react-intl';

export default defineMessages({
    subHeaderDesc: {
        id: 'ml.quoteandbind.hocondcoverages.subHeaderDesc',
        defaultMessage: 'These categories are covered up to the dollar amount and/or loss. Additional coverage can be obtained by adding either the Value Personal Property or Scheduled Personal Property optional coverage.'
    },
    viewAll: {
        id: 'ml.quoteandbind.hocondcoverages.viewAll',
        defaultMessage: 'VIEW ALL'
    },
    collapse: {
        id: 'ml.quoteandbind.hocondcoverages.collapse',
        defaultMessage: 'COLLAPSE'
    },
});
